<div class="am-flex-column gap-xs p-s bb-grey">
  <pagination-search [secondary]="'bulkMessages'" (callback)="loadBulkMessages()"></pagination-search>
  <div class="am-flex-align gap-xxs">
    <span class="am-flex-center height-xl pl-xs pr-xs b-radius-wide-xxs font-xs font-500 pointer word-no-wrap" [ngClass]="!filterKinds.length ? 'bg-blue color-white' : 'b-grey hover-active-bg'" (click)="toggleKind(null)">Alle</span>
    @for (k of kinds; track k.kind) {
      <span class="am-flex-center height-xl pl-xs pr-xs b-radius-wide-xxs font-xs font-500 pointer word-no-wrap" [ngClass]="filterKinds.includes(k.kind) ? 'bg-blue color-white' : 'b-grey hover-active-bg'" (click)="toggleKind(k.kind)">{{ k.label }}</span>
    }
  </div>
</div>

<div class="am-flex-column am-flex-1 font-s overflow-auto">
  @for (message of messages; track message.id) {
    <div class="am-flex-column gap-xxs pl-s pr-s pt-xs pb-xs bb-grey pointer" [ngClass]="expandedId === message.id ? 'bg-table-header-grey' : 'hover-active-bg'" (click)="toggle(message)">
      <div class="am-flex-align gap-xs">
        <span class="am-flex-align am-flex-shrink-0 gap-xxs height-l pl-xs pr-xs b-radius-wide font-xs font-500" [ngClass]="kindOf(message).style">
          <span class="am-flex-center font-s" [ngClass]="kindOf(message).icon"></span>
          <span>{{ kindOf(message).label }} · {{ message.recipientNames.length }}</span>
        </span>
        <span class="mla am-flex-shrink-0 font-xs color-secondary-grey word-no-wrap roboto" [title]="message.createdAt | date: 'dd.MM.yyyy, HH:mm'">{{ timeLabel(message) }}</span>
        <span class="am-flex-center am-flex-shrink-0 font-s color-secondary-grey" [ngClass]="expandedId === message.id ? 'icon-arrow-up' : 'icon-arrow-down'"></span>
      </div>
      <div class="am-flex-wrap gap-xxs">
        @for (name of visibleRecipients(message); track $index) { <span class="am-flex-align height-l pl-xs pr-xs b-grey b-radius-wide bg-white font-xs">{{ name }}</span> }
        @if (hiddenRecipients(message)) { <span class="am-flex-align height-l pl-xs pr-xs b-radius-wide bg-grey font-xs font-500 color-blue">+{{ hiddenRecipients(message) }} weitere</span> }
      </div>
      @if (expandedId === message.id) {
        <span class="lh-m pre-line word-break-word">{{ message.text }}</span>
        @if (message.editedAt) { <span class="font-xs color-secondary-grey">Bearbeitet</span> }
        @if (chatFullAccess) {
          <div class="am-flex-align gap-xxs">
            <span class="am-flex-align gap-xxs height-xxl pl-xs pr-xs b-grey b-radius bg-white font-xs font-500 hover-active-blue" (click)="$event.stopPropagation(); edit.emit(message)">
              <span class="am-flex-center icon-edit font-s"></span>
              <span>Bearbeiten</span>
            </span>
            <span class="am-flex-align gap-xxs height-xxl pl-xs pr-xs b-grey b-radius bg-white font-xs font-500 color-red hover-active" (click)="$event.stopPropagation(); deleteMessage(message)">
              <span class="am-flex-center icon-bin font-s"></span>
              <span>Löschen</span>
            </span>
          </div>
        }
      } @else {
        <span class="ellipsis color-secondary-grey">{{ message.text }}</span>
      }
    </div>
  } @empty { <span class="am-flex-center p-s">keine Gruppen vorhanden</span> }
</div>

@if (totalPages > 1) {
  <div class="p-s bt-grey">
    <pagination-secondary [totalPages]="totalPages" [page]="currentPage" [total]="meta?.total_count" [perPage]="meta?.per_page" (callback)="loadBulkMessages($event)"></pagination-secondary>
  </div>
}

<div class="p-s bt-grey">
  <span class="am-flex-center gap-xxs width-full height-36 bg-blue color-white b-radius font-s font-500 pointer hover-bg-light-blue" (click)="create.emit()">
    <span class="am-flex-center icon-plus font-l"></span>
    <span>Neue Gruppennachricht</span>
  </span>
</div>

@if (loading) {
  <div class="absolute-full bg-overlay-white events-none wait-animation">
    <div class="am-flex-center">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
  </div>
}
